<template>
  <div class="d-flex">
    <button class="btn details_btn mr-2" @click="reAssignPOSModal">
      {{ $t("text.clickButtons.reAssignPos") }}
    </button>
    <!-- <button class="btn details_btn " @click="createTerminal">
       create terminal 
    </button> -->

    <router-link
      :to="{
        name: 'company-pos-terminals-details',
        query: { terminalId: data.id, companyId:data.companyId},
      }"
    >
      <button class="btn details_btn" >View Details</button>
    </router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
    };
  },
  mounted() {},
  methods: {
    createTerminal() {
      this.$eventHub.$emit("_createTerminal", this.data);
    },
    showPOSDetailsModal() {
      this.$eventHub.$emit("showPOSDetailsModal", this.data);
    },
    reAssignPOSModal() {
      this.$eventHub.$emit("_reAssignPOSModal", this.data);
    },
  },
};
</script>